export function fmtDollars(n: number): string {
  return '$' + Math.round(Math.abs(n)).toLocaleString('en-US')
}

/** `$9.70M` at or above $1M, otherwise full dollars. */
export function fmtCompact(n: number): string {
  const abs = Math.abs(n)
  return abs >= 1_000_000 ? '$' + (abs / 1_000_000).toFixed(2) + 'M' : fmtDollars(abs)
}

export function fmtAxis(n: number): string {
  if (n >= 1_000_000) return '$' + (n / 1_000_000).toFixed(1) + 'M'
  if (n >= 1_000) return '$' + Math.round(n / 1_000) + 'K'
  return '$' + Math.round(n)
}

export type ReadinessTier = 'on-track' | 'almost' | 'attention'

export function getReadinessTier(ratio: number): ReadinessTier {
  if (ratio >= 1) return 'on-track'
  if (ratio >= 0.8) return 'almost'
  return 'attention'
}

export const TIER_LABEL: Record<ReadinessTier, string> = {
  'on-track': 'On track',
  almost: 'Almost there',
  attention: 'Needs attention',
}

export function getAdvisorMessage(ratio: number): { eyebrow: string; headline: string } {
  if (ratio >= 1.2) return { eyebrow: 'You may be over-saving', headline: 'Are you working longer than you need to?' }
  if (ratio >= 0.95) return { eyebrow: "You're ahead of schedule", headline: 'Curious if your plan has gaps?' }
  if (ratio >= 0.7) return { eyebrow: "You're making progress", headline: 'Wonder what you might be missing?' }
  return { eyebrow: "There's ground to make up", headline: 'Not sure where to start?' }
}
